import React from "react"
import { Card, CardBody } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"

const FacilityListComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onClickDelete,
  handleDeleteFunc,
  onExportBtnClick,
  exportStatus,
}) => {
  const navigate = useNavigate()
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CustomHeaderTitle
            loading={loading} //Boolean flag to display loading state
            title={"List"} // String to display as the header title
            rowCount={true} // Boolean to show/hide the row number selector
            onChangeRowNumber={onChangeRowNumber} // Callback function to handle row number selection change
            orderingList={true} // Boolean to show/hide ordering dropdown
            onChangeOrdering={onChangeOrdering} //  Callback function triggered when the ordering option is changed
            searchBox={true} // Boolean to show/hide search input box
            onSearchHandler={onSearch} // Function called on key up in the search box
            exportBtn={true} // Boolean to show/hide export button
            onExportBtnClick={onExportBtnClick} // Callback for when the export button is clicked
            exportBtnLoading={exportStatus?.loading} // Boolean flag to show loading state during export functionality
            rightBtn={true} // Boolean to show/hide right-side button (for example, a back button)
            rightBtnTitle={"Add Facility"} // String for setting the right button's label
            rightBtnRoute={"/add-facility"} // Route for the right button's navigation
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "facility_name", name: "Facility Name" },
              { value: "facility_type", name: "Facility Type" },
              { value: "facility_code", name: "Facility Code" },
            ]} // Array of options to populate the ordering dropdown (value and name pair)
          />
          <GeneralTables
            data={data?.data} // Array containing the data to be displayed in the table
            loading={loading} // Boolean indicating the loading state of the table
            headers={[
              "#",
              "Province",
              "Facility Name",
              "Facility Type",
              "Facility Code",
              "Action",
            ]} // Array of strings representing the column headers for the table
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(province, index) => (
              <tr key={index}>
                <th scope="row">{data?.meta?.from + index}</th>
                <td>{province.province.province}</td>
                <td>{province.facility_name}</td>
                <td>{province.facility_type}</td>
                <td>{province.facility_code}</td>
                <td>
                  <ActionColumns
                    data={province}
                    enableEdit={true}
                    enableDelete={true}
                    editRoute={`/edit-facility/${province.id}`}
                    onClickDelete={onClickDelete}
                  />
                </td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default FacilityListComponent
